import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface SpinnerProps {
	size?: "sm" | "md" | "lg";
	className?: string;
}

export function Spinner({ size = "md", className }: SpinnerProps) {
	const sizeClasses = {
		sm: "h-4 w-4",
		md: "h-8 w-8",
		lg: "h-12 w-12",
	};

	return (
		<Loader2 className={cn("animate-spin text-muted-foreground", sizeClasses[size], className)} />
	);
}

interface LoadingSpinnerProps {
	message?: string;
	size?: "sm" | "md" | "lg";
	className?: string;
}

export function LoadingSpinner({
	message = "Loading...",
	size = "md",
	className,
}: LoadingSpinnerProps) {
	return (
		<div className={cn("flex flex-col items-center justify-center space-y-2", className)}>
			<Spinner size={size} />
			{message && <p className="text-sm text-muted-foreground">{message}</p>}
		</div>
	);
}
